import { Field, Int, ObjectType } from '@nestjs/graphql'
import { IdDto } from '../../base'

@ObjectType()
export class ReviewerThreadUserDto extends IdDto{
  @Field()
  existingThreadCount!: number

  @Field(t => Int, { nullable: true })
  userId?: number

  @Field({ nullable: true })
  modelKey?: string

  @Field({ nullable: true })
  name?: string

  @Field({ nullable: true })
  image?: string
}
